import { render, staticRenderFns } from "./CustomerShowPayment.vue?vue&type=template&id=b4624f5c"
import script from "./CustomerShowPayment.vue?vue&type=script&lang=js"
export * from "./CustomerShowPayment.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowPayment.vue?vue&type=style&index=0&id=b4624f5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports